function initGallery() {
	if ( window.outerWidth < 767 ) {
		const options = {
			slidesPerView: 'auto',
			spaceBetween: 0,
			pagination: {
				el: '.swiper-pagination',
				type: 'progressbar',
			}
		};

		const gallery = new Swiper('.product-gallery .swiper', options); 
		console.log(gallery);
	}
}

function pdpImageSets() {
	if (window.outerWidth > 990 || !document.querySelector('.pdp-worn-by') ) return;
	let options = {
		slidesPerView: 'auto',
		navigation: {
			nextEl: '.swiper-button-next',
		},
		spaceBetween: 1,
		breakpoints: {
			767: {
				slidesPerView: 2
			}
		}
	}

	const slider = new Swiper('.pdp-worn-by .swiper', options);
}

function pdpRemoveStyling() {
	const description = document.querySelector('.pdp-desc');
	if (description) {
		description.querySelectorAll('[style]').forEach((el) => {
			el.removeAttribute('style');
		}
		);
	}
}

function announcementBarSpacing() {
	const announcementBar = document.querySelector('.custom-bar');
	if ( announcementBar  ) {
		const footer = document.querySelector('.footer');
		footer.style.paddingBottom = announcementBar.offsetHeight + 'px';
	}
}

window.addEventListener('DOMContentLoaded', (event) => {
	initGallery();
	pdpImageSets();
	pdpRemoveStyling();
	announcementBarSpacing();
});